/**
 * @author Harshitha.k
 * @description 
 */

import { connect } from 'react-redux';
import React, { useState, useEffect, useRef } from 'react';
import ListView from '../../AMM/Utils/ListView';
import { MAXIMOASSET } from '../../../commons/api';
import { Button, Space, Switch } from 'antd';
import { getMasterList } from './Utils/FormCalls';

const urlList = {
  list: `${MAXIMOASSET.GetAFCList}`
};

const StatusScreen = (props) => {

  const [dataSource, setDataSource] = useState([]);
  const [translationCache, setTranslationCache] = useState(props.translationCache || []);
  const [userProfile, setUserProfile] = useState(props.userProfile || {});
  const formRef = useRef();

  useEffect(() => {
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }
    if (props.userProfile !== userProfile) {
      setUserProfile(props.userProfile);
    }
    _getAdhocDataSource();
  }, [props.translationCache, props.userProfile]);

  const _getAdhocDataSource = async () => {
    try {
      const path = props.location?.pathname.split('/rubus/Maximo/');
      const Module = path[1]?.split('/')?.[0];
      const dataSource1 = await getMasterList(urlList.list, Module, 'Asset');
      if (dataSource1) {
        setDataSource(dataSource1);
      } else {
        console.error("Data source is undefined or null");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Define _deleteById function
  // const _deleteById = (id) => {
    // Add your delete logic here
    // For example:
    // setDataSource(dataSource.filter(item => item.Id !== id));
  // };

  // const handleSearch = (selectedKeys, confirm) => {
  //   confirm();
  //   setSearchText(selectedKeys[0]);
  // };

  // const handleReset = (clearFilters, confirm) => {
  //   clearFilters();
  //   handleSearch([], confirm);
  // };

  // const getColumnSearchProps = (dataIndex) => ({
  //   filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
  //     <div style={{ padding: 8 }}>
  //       <Input
  //         ref={searchInput}
  //         placeholder={translation(props.translationCache, constant.search)}
  //         value={selectedKeys[0]}
  //         onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
  //         onPressEnter={() => handleSearch(selectedKeys, confirm)}
  //         style={{ width: 188, marginBottom: 8, display: 'block' }}
  //       />
  //       <Button
  //         type="primary"
  //         onClick={() => handleSearch(selectedKeys, confirm)}
  //         icon={<SearchOutlined />}
  //         
  //         style={{ width: 90, marginRight: 8 }}
  //       >
  //         {translation(props.translationCache, constant.search)}
  //       </Button>
  //       <Button
  //         onClick={() => handleReset(clearFilters, confirm)}
  //         
  //         style={{ width: 90 }}
  //       >
  //         {translation(props.translationCache, constant.Reset)}
  //       </Button>
  //     </div>
  //   ),
  //   filterIcon: (filtered) => (
  //     <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
  //   ),
  //   onFilter: (value, record) =>
  //     record &&
  //     record[dataIndex] &&
  //     record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
  //   onFilterDropdownOpenChange: () => {
  //     if (visible) {
  //       setTimeout(() => searchInput.current.select());
  //     }
  //   },
  //   render: (text) => (
  //     <Highlighter
  //       highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
  //       searchWords={[searchText]}
  //       autoEscape
  //       textToHighlight={text && text.toString()}
  //     />
  //   )
  // });

  

  const columns =  [
    {
      title: 'S.No',
      dataIndex: 'S.No',
      key: 'S.No'
    },
    {
      title: 'Asset ',
      dataIndex: 'AssetName',
      key: 'AssetName',
      filter: true
    },
    {
      title: 'AssetType',
      dataIndex: 'assetTypeName',
      key: 'assetTypeName'
    },
    {
      title: 'Fault Code',
      dataIndex: 'FaultName',
      key: 'FaultName'
    },
    {
      title: 'Halt Status',
      render: (record) => (
        <Switch
          key={record.Id}
          style={{ cursor: 'not-allowed', opacity: 1 }}
          defaultChecked={record.HaltStatus ? true : false}
          disabled
        />
      )
    },
    {
      title: 'Interval Status',
      render: (record) => (
        <Switch
          key={record.Id}
          style={{ cursor: 'not-allowed', opacity: 1 }}
          defaultChecked={record.IntervalStatus ? true : false}
          disabled
        />
      )
    },
    {
      title: 'Fault Interval',
      dataIndex: 'Interval',
      key: 'Interval',
      editable: true
    },
    {
      title: 'Edit',
      dataIndex: 'Edit',
      key: 'Edit',
      render: (text, record) => (
        <Space>
          <Button
            className="ant-btn"
            onClick={() => editHalt(record,'Asset')}
            
          >
            Halt Edit
          </Button>
          <Button className="ant-btn" onClick={() => editInterval(record)} >
            Interval Edit
          </Button>
        </Space>
      )
    }
  ]
;

  const config = {
    title: 'Status Screen Asset',
    viewTypes: ['table'],
    defaultViewType: 'table',
    firstTitle: 'Status Screen',
    secondTitle: 'CreatedBy',
    thirdTitle: 'CreatedTime',
    actions: ['edit'],
    edit: {
      byAttribute: 'Id',
      redirectURL: ''
    },
    deletee: {
      byAttribute: 'Id'
    }
  };

  const editHalt = (record) => {
    let path = props.location.pathname.split('/rubus/Maximo/');
    let Module = path[1].split('/') && path[1].split('/')[0];
    props && props.navigate({
      pathname: `/rubus/Maximo/${Module}/SRHaltTime`,
      state: {
        record
      }
    });
  };

  const editInterval = (record) => {
    let path = props.location.pathname.split('/rubus/Maximo/');
    let Module = path[1].split('/') && path[1].split('/')[0];
    props.navigate({
      pathname: `/rubus/Maximo/${Module}/SRWaitInterval`,
      state: {
        record
      }
    });
  };

  return (
    <>
      <ListView
        ref={formRef}
        columns={Array.isArray(columns) ? columns : []}
        dataSource={Array.isArray(dataSource) ? dataSource : []}
        config={config}
        // delete={_deleteById} // Pass _deleteById directly
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache
});

export default connect(mapStateToProps)(StatusScreen);
